/**
 * @file: useServiceRecordNavigation.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import type { ServiceRecordNavParams } from '@euler/app/flows/record/ServiceRecordFlow';
import type { AppNavParams } from '@euler/app/Routes';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

export const useServiceRecordNavigation = () => {
  return useNavigation<
    StackNavigationProp<AppNavParams & ServiceRecordNavParams>
  >();
};
